import React, { useEffect } from "react";
import { Container } from "@montana/shared/container";
import { ProgressBar, IProgressStep } from "./progress-bar";
import { useCart } from "@montana/containers/cart";
import { useTranslations } from "@montana/containers/translations";
import { useRouter } from "@montana/containers/router";
import { useSettings } from "@montana/containers/settings/settings.container";
import { StaticHeroComponent } from "@montana/shared/static-hero/static-hero.component";
import { useDynamicSettings } from "@montana/containers/dynamic-settings";

export interface ICheckoutPage {
    children?: React.ReactChild;
    progressBarIndex?: number;
    progressBarAllowNavigationBack?: boolean;
    progressBarAllowNavigationForward?: boolean;
}

export const CheckoutPage: React.FC<ICheckoutPage> = ({ children, progressBarIndex, progressBarAllowNavigationBack, progressBarAllowNavigationForward }: ICheckoutPage): JSX.Element => {
    const translate = useTranslations();
    const { lines, cartGhostCount } = useCart();
    const { market } = useSettings();
    const { push } = useRouter();
    const { links } = useDynamicSettings();

    useEffect(() => {
        if (market?.disableCart) {
            push('/');
        }
    }, [market]);

    const cartQuantity = lines && lines.reduce((acc, l) => (l.quantity || 0) + acc, 0) || 0;

    const steps: IProgressStep[] = [
        {
            title: translate((translations): string => translations.checkoutPage.progressBarBasket.replace('{0}', cartGhostCount || cartQuantity), "Select a variation"),
            link: links?.cart || ''
        },
        {
            title: translate((translations): string => translations.checkoutPage.progressBarAddressAndDelivery, 'Address & Delivery'),
            link: links?.checkout || ''
        },
        {
            title: translate((translations): string => translations.checkoutPage.progressBarYourReceipt, 'Your Receipt'),
            link: links?.receipt || ''
        }
    ];

    return (
        <Container className="checkout-page">
            <StaticHeroComponent className="checkout__hero">
                <ProgressBar
                    currentIndex={progressBarIndex}
                    allowNavigationBack={progressBarAllowNavigationBack}
                    allowNavigationForward={progressBarAllowNavigationForward}
                    steps={steps}
                />
            </StaticHeroComponent>
            {children}
        </Container>
    );
};
